import React from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const ServicesPage = () => {
  const agencySolutions = [
    { title: "1. Student CRM & Application Pipeline", desc: "Centralized lead acquisition, counsellor lead assignment, application stage tracking (Applied, Offer Received, CAS Issued, Visa Filed), and document vault.", icon: "fa-users-cog" },
    { title: "2. AI University Shortlisting Tool", desc: "Instantly match student CGPA, IELTS/GRE scores, work experience, and financial budget with 1,000+ global partner programs and real-time admission odds.", icon: "fa-microchip" },
    { title: "3. Automated SOP & LOR Draft Generator", desc: "AI-driven Statement of Purpose (SOP) and Recommendation Letter (LOR) draft generator formatted specifically for UK, US, Canada, Australia, and Germany universities.", icon: "fa-file-signature" },
    { title: "4. Commission & Sub-Agent Financials", desc: "Track university commission payouts, sub-agent revenue sharing splits, student fee receipts, and referral invoicing in real time.", icon: "fa-coins" },
    { title: "5. Multi-Tenant Role & Branch Management", desc: "Granular access permissions for Super Admin, Agency Franchise Directors, Counsellors, Application Assistants, and Loan Officers.", icon: "fa-user-shield" },
    { title: "6. Integrated Loan & Forex Referrals", desc: "Direct integration with banking partners for processing student collateral/non-collateral education loans and Forex transfers, generating extra agency revenue.", icon: "fa-hand-holding-usd" },
    { title: "7. 100% Student Visa Operations Desk", desc: "Visa checklist automation, financial proofing tools, CAS/I-20 tracking, and simulated mock visa interview practice modules.", icon: "fa-passport" },
    { title: "8. Help Desk & Ticketing Hub", desc: "Built-in internal ticketing system to resolve counsellor questions, document rejections, and partner university queries.", icon: "fa-headset" },
  ];

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Header */}
      <section className="py-5 consultancy-section-dark text-center">
        <div className="container">
          <span className="consultancy-badge-gold mb-2">Agency Operating Software</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">EdOps Consultancy Operating Solutions</h1>
          <p className="consultancy-lead-text mx-auto" style={{ maxWidth: "650px" }}>
            Automate student applications, scale admissions 3x, track university commissions, and streamline staff workflows with our cloud platform.
          </p>
        </div>
      </section>

      {/* Solutions Grid */}
      <section className="py-5 container">
        <div className="row g-4">
          {agencySolutions.map((s, idx) => (
            <div key={idx} className="col-lg-6">
              <div className="consultancy-glass-card p-4 h-100 d-flex gap-4 align-items-start">
                <div className="avatar bg-soft-warning text-warning p-3 rounded-circle" style={{ width: "56px", height: "56px", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className={`fas ${s.icon} fa-xl`}></i>
                </div>
                <div>
                  <h4 className="font-weight-bold consultancy-gold-title mb-2">{s.title}</h4>
                  <p className="text-muted small mb-0" style={{ lineHeight: "1.7" }}>{s.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-5 pt-4">
          <Link to="/consultancy/book-consultation" className="consultancy-btn-gold px-5 py-3">
            Schedule Agency Platform Demo <i className="fas fa-desktop ml-1"></i>
          </Link>
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default ServicesPage;
